import SettingsCard from "./ui/SettingsCard";

export default function PrivacySection() {
  return (
    <SettingsCard title="Profile Visibility">
      <p>Control who can see your profile.</p>
    </SettingsCard>
  );
}